import React from "react";
import { i18n } from "@euroland/libs";
import { TOOL_TEMPLATE } from "../../constant/common";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import { useSelector } from "react-redux";
import { getHistoricalPricesSelector, instrumentDataAndSettingSelector } from "../../store/slice/trade";
import { HighChartMultipleLine, HighChartsLineAndVolume } from "../HighCharts";
import LoadingWrapper from "../ui/LoadingWrapper";
import TickerLengendMultipleLineChart from "../HighCharts/TickerLengendMultipleLineChart";

const SharePriceChart = ({ isSingle }) => {
  const template = useTemplateSetting();

  const historicalPrices = useSelector(getHistoricalPricesSelector);
  const instrumentDataAndSetting = useSelector(instrumentDataAndSettingSelector);

  const isSingleInner = isSingle === undefined ? historicalPrices.ids.length === 1 : isSingle;

  const isVictor = template === TOOL_TEMPLATE.victor;

  return (
    <div className="share-price__chart">
      {historicalPrices.ids.length > 0 && (
        <>
          {isSingleInner && (
            <LoadingWrapper isShow={historicalPrices.loading}>
              <HighChartsLineAndVolume
                series={historicalPrices.list[0]}
                instrumentDataAndSetting={instrumentDataAndSetting}
              />
            </LoadingWrapper>
          )}
          {!isSingleInner && (
            <LoadingWrapper isShow={historicalPrices.loading}>
              <HighChartMultipleLine
                series={historicalPrices.list}
                instrumentDataAndSetting={instrumentDataAndSetting}
              />
              <TickerLengendMultipleLineChart datas={historicalPrices.list} />
            </LoadingWrapper>
          )}
        </>
      )}

      {isVictor && historicalPrices.ids.length === 0 && (
        <p className="no-data-text" role='note' tabIndex={0}>
          {i18n.translate("noData")}
        </p>
      )}
    </div>
  );
};

export default SharePriceChart;
